import React, {useState} from 'react';
import {useQuery} from "@apollo/client";
import {useHistory} from 'react-router-dom';
import withStyles from '@mui/styles/withStyles';
import Button from '@mui/material/Button';
import {useMutation} from "@apollo/client";
import {FINISH_QUESTIONNAIRE} from '../../queries/mutations';
import {GET_QUESTIONS} from '../../queries/queries';
import Bar from '../bar';
import Success from './success';
import TryAgain from './try-again';
import Questions from './questions';
import Loading from '../loading';
import Error from '../error';

const Questionnaire = ({
  match: {
    params: {lectionId},
  },
}) => {
  let history = useHistory();
  const [answers, setAnswers] = useState({});
  const [successVisible, setSuccessVisible] = useState(false);
  const [tryAgainVisible, setTryAgainVisible] = useState(false);
  const [percent, setPercent] = useState();

  const handleAnswer = (questionId, answer, questionType) => {
    if (questionType === 'MultiSelectQuestion') {
      setAnswers(prevState => {
        const answers = prevState[questionId] || [];
        if(answers.includes(answer)){
          answers.splice( answers.indexOf(answer), 1 );
        } else {
        answers.push(answer)
        }
        const newState = {...prevState, [questionId]: answers}
        return newState;
      });
    } else {
      setAnswers(prevState => ({...prevState, [questionId]: answer}));
    }
  };

  const [finishQuestionnaire] = useMutation(FINISH_QUESTIONNAIRE, {
    onCompleted({finishQuestionnaire: {result}}) {
      if (result < 90) {
        setTryAgainVisible(true);
        setPercent(result);
      } else {
        setSuccessVisible(true);
      }
    },
  });

  const handleQuestionnaireSubmit = () => {
    const userId = localStorage.getItem('user_id');
    finishQuestionnaire({
      variables: {
        userId: userId,
        answers: JSON.stringify(answers),
      },
    });
  };

  const {loading, error, data} = useQuery(GET_QUESTIONS, {
    fetchPolicy: 'no-cache',
    variables: {sectionId: lectionId},
  });

  const retry = () => {
    setTryAgainVisible(false);
  };

  if (loading) return <Loading />;
  if (error) return <Error />;

  const questions = data.questions;

  const Content = () => {
    if (successVisible) {
      return <Success />;
    } else if (tryAgainVisible) {
      return <TryAgain percent={percent} lectionId={lectionId} />;
    } else {
      return (
        <Questions
          questions={questions}
          answers={answers}
          handleAnswer={handleAnswer}
        />
      );
    }
  };

  const BarContent = () => {
    if (successVisible) {
      return (
        <Button
          color="primary"
          variant="contained"
          onClick={e => history.push('/')}>
          Zur Lektionsübersicht
        </Button>
      );
    } else if (tryAgainVisible) {
      return (
        <Button color="secondary" variant="contained" onClick={retry}>
          Erneut versuchen
        </Button>
      );
    } else {
      return (
        <Button
          color="primary"
          variant="contained"
          onClick={handleQuestionnaireSubmit}>
          Absenden
        </Button>
      );
    }
  };

  return (
    <>
      <Bar>
        <BarContent />
      </Bar>
      <div style={{ backgroundColor: "#ffff" }}>
        <Content />
      </div>
    </>
  );
};

export default Questionnaire;
